import React, { Component } from 'react';
import { connect } from "react-redux";
import { Grid } from 'react-bootstrap';

import './App.css';
import Header from './header/Header'
import Index from './screens/Index'
import CurriculumVitae from './screens/CurriculumVitae'
import LegalAreas from './screens/LegalAreas'
import Works from './screens/Works'
import Contact from './screens/Contact'

class App extends Component {
  router() {
    switch (this.props.screen) {
      case 'Index':
        return <Index />
      case 'CurriculumVitae':
        return <CurriculumVitae />
      case 'LegalAreas':
        return <LegalAreas />
      case 'Works':
        return <Works />
      case 'Contact':
        return <Contact />
      default:
        return <Index/>
    }
  }
  render() {

    let CurrentScreen = this.router(this.props.screen)

    return (
      <div> 
        <Grid fluid={false} className="main">

          <Header/>

          {CurrentScreen}

        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { 
    screen: state.screen
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateLanguage: language => dispatch({ type: 'UPDATE_LANGUAGE', payload: language })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);




// WEBPACK FOOTER //
// ./src/App.js